export default {
    //URL: "https://webapi.4gflota.com/api/",
    URL: "https://4yahqnkrsh.execute-api.eu-west-1.amazonaws.com/Prod/api/", //desarrollo
    API_KEY_Google_Maps: "AIzaSyDXhVYV0tKNy9kgA6mdHKX2F2H8LlbGnhk"
};